<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-calendar-days"></i></div>
      <div>
        Emploi du temps
        <div class="page-title-subheading">Planning hebdomadaire des cours par classe</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div class="mb-3">

    <div class="d-flex justify-content-between align-items-end mb-3 gap-3 flex-wrap">
    <div class="btn-group" role="group" aria-label="Mode d'affichage">
        <button type="button" class="btn btn-sm {{viewer==1 ? 'btn-danger':'btn-outline-secondary'}}"
                (click)="reload(1)" title="Vue par jour">
            <i class="fa fa-list me-1" aria-hidden="true"></i>Par jour
        </button>
        <button type="button" class="btn btn-sm {{viewer==2 ? 'btn-danger':'btn-outline-secondary'}}"
                (click)="reload(2)" title="Vue calendrier de la semaine">
            <i class="fa fa-table-cells me-1" aria-hidden="true"></i>Semaine
        </button>
    </div>
    <div class="form-group ms-auto" style="min-width: 240px;">
        <label for="classroom_select" class="form-label mb-0"><strong>Classe</strong></label>
        <select id="classroom_select" class="form-select form-select-sm" (change)="loadPacs($event)" name="classroom_select">
            <option selected disabled>Choisir une classe</option>
            <option *ngFor="let c of classrooms" [value]="c.id">{{c.name}}</option>
        </select>
    </div>
    </div>

    <div class="alert alert-info" *ngIf="!classroomSelected">
        Choisissez une classe pour afficher son emploi du temps.
    </div>
  

    <ng-container *ngIf="viewer==1">
        <div class="row" *ngIf="paccs.length!=0">
            <div class="col-12 col-md-4 mb-3" *ngFor="let dow of dows; let i=index">
                <div class="card" style="height: 18rem; overflow-y: scroll;">
                    
                    <div class="card-body">
                      <div class="">
                          <h6 class="text-center">{{dow.day}}</h6>
                          <br>
                          <div class="d-flex justify-content-between">
                              <button class="btn btn-info btn-sm btn-label waves-effect waves-ligh text-center me-3" (click)="add(addContent,dow.id)">Ajouter un programme de cours</button>
                              <button class="btn btn-warning btn-sm btn-label waves-effect waves-ligh text-center me-3" (click)="add(add2Content,dow.id)">Ajouter un programme de coutûme</button>
                          </div>
                          <hr>
                              <div class="d-flex mb-3" *ngFor="let p of getPrograms(dow.day_number)" style="height: 5rem;">
                                  <div class="" style="height: 5rem;width:5px;background-color: {{p.pacc?.course?.color}};"></div>
                                  <div class="p-1">
                                      <strong>
                                          
                                          <span *ngIf="p.name==null">{{p.pacc?.course?.name}}</span>
                                          <span *ngIf="p.name!=null">{{p.name}}</span>
                                          
      
                                          <i *ngIf="p.pacc_id!=null" class="fa fa-pencil text-warning pointer ms-auto px-1" (click)="edit(editContent,p)"></i>
                                          <i class="fa fa-times text-danger pointer ms-auto px-1" (click)="delete(p.id)"></i>
      
                                      </strong>
                                      <br>
                                      <span>{{p.start_time}} - {{p.end_time}}</span>
                                          <br>
                                      <span>{{p.pacc?.pac?.professor?.lastname}} {{p.pacc?.pac?.professor?.firstname}}</span>
                                  </div>
                                  
                              </div>
                        
                      </div>
                      
                    </div><!-- end card -->
                </div>
                <!-- end col -->
            </div>
            <!-- end col -->
        </div>
    </ng-container>
    <ng-container *ngIf="viewer==2">
        <app-simple-calendar *ngIf="calendars" [data]="calendars"></app-simple-calendar>
    </ng-container>

  


</div>
  <ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un programme</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Jour de la semaine <span class="text-danger ml-2">(*)</span></label>
                <select name="dow_id" class="form-control" [(ngModel)]="dow_id" disabled>
                    <option *ngFor="let dow of dows" [value]="dow.id">{{dow.day}}</option>
                </select>
            </div>
            <!-- <div class=" form-group col-12 mb-3">
                <label for="">Enseignant<span class="text-danger ml-2">(*)</span></label>
                <select class="form-control" (change)="loadCourses($event)" >
                    <option selected disabled></option>
                    <option *ngFor="let pacc of paccs" [value]="pacc.id">{{pacc.professor?.lastname}} {{pacc.professor?.firstname}}</option>
                </select>
            </div> -->
            <div class=" form-group col-12 mb-3">
                <label for="">Matière<span class="text-danger ml-2">(*)</span></label>
                <select name="pacc_id" ngModel class="form-control" (change)="setPaccId($event)" >
                    <option *ngFor="let c of courses" [value]="c.id">{{c.name}} ({{c.professor}})</option>
                </select>
            </div>
            <span class="text-primary pointer text-underline text-end" (click)="openAdvanced=!openAdvanced">option avancé</span>
            <ng-container *ngIf="openAdvanced">
                <div class=" form-group col-12 mb-3">
                    <label for="">Rubrique<span class="text-danger ml-2">(*)</span></label>
                    <select name="sub_course_id" ngModel class="form-control">
                        <option *ngFor="let c of subcourses" [value]="c.id">{{c.name}}</option>
                    </select>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Libellé à afficher <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="name" class="form-control" ngModel required>
                </div>
            </ng-container>

            <ng-container *ngIf="!openAdvanced">
                <div class=" form-group col-12 mb-3">
                    <label for="">Libellé à afficher</label>
                    <input type="text" name="name" class="form-control" ngModel>
                </div>
            </ng-container>
            
            
            <div class=" form-group col-12 mb-3">
                <label for="">Heure de demarrage <span class="text-danger ml-2">(*)</span></label>
                <input type="time" name="start_time" class="form-control" [min]="minDate"  [max]="maxDate" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">heure de fin <span class="text-danger ml-2">(*)</span></label>
                <input type="time" name="end_time" class="form-control" ngModel>
            </div>

            <div class="d-flex justify-content-between p-1">
                <span><strong>Matière par quinzaine</strong></span>
                <span>
                    <ui-switch  name="authorize"  ngModel></ui-switch>
                </span>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
  <ng-template #add2Content let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store2(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un programme</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Jour de la semaine <span class="text-danger ml-2">(*)</span></label>
                <select name="dow_id" class="form-control" [(ngModel)]="dow_id" disabled>
                    <option *ngFor="let dow of dows" [value]="dow.id">{{dow.day}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé à afficher <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Heure de demarrage <span class="text-danger ml-2">(*)</span></label>
                <input type="time" name="start_time" class="form-control" [min]="minDate"  [max]="maxDate" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">heure de fin <span class="text-danger ml-2">(*)</span></label>
                <input type="time" name="end_time" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="update(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier le  programme</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Matière<span class="text-danger ml-2">(*)</span></label>
                <select name="pacc_id" [(ngModel)]="selected_data.pacc.course.id" class="form-control" (change)="setPaccId($event)" >
                    <option *ngFor="let c of courses" [value]="c.id">{{c.name}}</option>
                </select>
            </div>
            <span class="text-primary pointer text-underline text-end" (click)="openAdvanced=!openAdvanced">option avancé</span>
            <ng-container *ngIf="openAdvanced">
                <div class=" form-group col-12 mb-3">
                    <label for="">Rubrique<span class="text-danger ml-2">(*)</span></label>
                    <select name="sub_course_id" [(ngModel)]="selected_data.sub_course_id" class="form-control">
                        <option *ngFor="let c of subcourses" [value]="c.id">{{c.name}}</option>
                    </select>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Libellé à afficher <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="name" class="form-control" [(ngModel)]="selected_data.name" required>
                </div>
            </ng-container>
            <ng-container *ngIf="!openAdvanced">
                <div class=" form-group col-12 mb-3">
                    <label for="">Libellé à afficher</label>
                    <input type="text" name="name" class="form-control" [(ngModel)]="selected_data.name">
                </div>
            </ng-container>
            <div class=" form-group col-12 mb-3">
                <label for="">Heure de demarrage <span class="text-danger ml-2">(*)</span></label>
                <input type="time" name="start_time" [(ngModel)]="selected_data.start_time" class="form-control" [min]="minDate"  [max]="maxDate" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">heure de fin <span class="text-danger ml-2">(*)</span></label>
                <input type="time" name="end_time" class="form-control" [(ngModel)]="selected_data.end_time" >
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>